import React, { useState } from 'react'
import { Col, Row, Space, Table, Card, Button, Tag, Divider, Input } from "antd";
import { ArrowLeftOutlined, CheckOutlined, SearchOutlined, SendOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import CheckThaiPost from './modal/CheckThaiPost';
import ConfirmLetter from './modal/ConfirmLetter';
import { getStatusColor, computeTabStatus } from './hook/function';

function DetailView({ initialData, selectedDate, activeCalendarTab, onBack, onReload }) {
  const dayDataMaster = initialData || [];
  const [dayData, setDayData] = useState(dayDataMaster);
  const [detailFilterStatus, setDetailFilterStatus] = useState("ทั้งหมด");
  const [detailSearchText, setDetailSearchText] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowDatas, setSelectedRowDatas] = useState([]);
  const [isModalCheckThaiPost, setIsModalCheckThaiPost] = useState(false);
  const [isModalConfirmLetter, setIsModalConfirmLetter] = useState(false);

  const onDetailSearch = (value) => {
    setDetailFilterStatus("ทั้งหมด");
    if (!value || value.trim() === "") {
      setDayData(dayDataMaster);
      return;
    }
    const keyword = value.trim();
    const result = dayDataMaster.filter(item =>
      (item.CONTNO && item.CONTNO.includes(keyword)) ||
      (item.customerFullName && item.customerFullName.includes(keyword)) ||
      (item.parcelNo && item.parcelNo.includes(keyword)) ||
      (item.parcelNoResponse && item.parcelNoResponse.includes(keyword))
    );
    setDayData(result);
  };

  const handleDetailFilterStatus = (value) => {
    setDetailFilterStatus(value);
    if (value === "ทั้งหมด") {
      setDayData(dayDataMaster);
      return;
    }
    const filtered = dayDataMaster.filter((item) => {
      if (["บอกกล่าว", "สิทธิซื้อรถคืน", "แจ้งราคาขายรถ", "บอกเลิก", "แจ้งผลประมูล"].includes(value)) return item?.status1 === value;
      if (["อยู่ระหว่างการนำจ่าย", "นำจ่ายไม่สำเร็จ", "นำจ่ายสำเร็จ"].includes(value)) return item?.status2 === value;
      if (["รอคอนเฟิร์ม", "คอนเฟิร์มแล้ว"].includes(value)) return item?.status3 === value;
      if (["ส่งถึงแล้วไม่ตอบกลับ", "ไม่มีการเคลื่อนไหว", "ตอบกลับ", "ตีกลับ", "ตอบกลับ(เว็บ)", "ตีกลับ(เว็บ)"].includes(value)) return item?.status4 === value;
      return false;
    });
    setDayData(filtered);
  };

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRowDatas(selectedRows);
  };

  const rowSelection = { selectedRowKeys, onChange: onSelectChange };

  const columns = [
    {
      title: "ลำดับ",
      key: "key",
      align: "center",
      render: (_, record) => <>{record.key}</>,
    },
    {
      title: "รายละเอียดลูกค้า",
      dataIndex: "customerFullName",
      key: "customerFullName",
      align: "center",
      render: (_, record) =>
        <>
          <div>{record?.customerFullName}</div>
          <div>
            {record?.typeReply === 1 ? `(คนค้ำ${record?.customerTypeId})` :
              record?.typeReply === 2 && record?.customerTypeId === 0 ? "(ผู้เช่าซื้อ)" :
                record?.typeReply === 2 && record?.customerTypeId !== 0 ? `(คนค้ำ${record?.customerTypeId})` :
                  record?.typeReply === 3 && record?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                    record?.typeReply === 3 && record?.customerTypeId !== 0 ? `(คนค้ำ${record?.customerTypeId})` :
                      record?.typeReply === 4 && record?.customerTypeId === 0 ? "(ผู้ทำสัญญา)" :
                        record?.typeReply === 4 && record?.customerTypeId !== 0 ? `(คนค้ำ${record?.customerTypeId})` :
                          record?.typeReply === 88 && record?.customerTypeId === 0 ? `(ผู้ทำสัญญา)` :
                            record?.typeReply === 88 && record?.customerTypeId !== 0 ? `(คนค้ำ${record?.customerTypeId})` :
                              "-"} ({record?.CONTNO})
          </div>
        </>,
    },
    {
      title: "ems จดหมาย",
      dataIndex: "parcelNo",
      key: "parcelNo",
      align: "center",
    },
    {
      title: "ems ใบตอบกลับ",
      dataIndex: "parcelNoResponse",
      key: "parcelNoResponse",
      align: "center",
    },
    {
      title: "รายละเอียด",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (_, record) =>
        <div style={{ textAlign: "left" }}>
          <div>ประเภทจดหมาย: <Tag color={getStatusColor(record.status1)}>{record.status1 !== "" ? record.status1 : "-"}</Tag></div>
          <div>จัดส่ง: <Tag color={getStatusColor(record.status2)}>{record.status2 !== "" ? record.status2 : "-"}</Tag></div>
          <div>คอนเฟิร์ม: <Tag color={getStatusColor(record.status3)}>{record.status3 !== "" ? record.status3 : "-"}</Tag></div>
          <div>ตอบกลับ: <Tag color={getStatusColor(record.status4)}>{record.status4 !== "" ? record.status4 : "-"}</Tag></div>
        </div>,
    },
  ];

  return (
    <>
      <Card>
        <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
          <Col span={24} style={{ textAlign: 'start' }}>
            <Button icon={<ArrowLeftOutlined />} onClick={onBack} style={{ marginRight: 16 }}>
              กลับปฏิทิน
            </Button>
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
              วันที่: {dayjs(selectedDate).format('DD/MM/YYYY')}
            </span>
          </Col>
          <Divider />
          <Col span={24} style={{ marginBottom: 8 }}>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {[
                { status: "ทั้งหมด", nameStatus: "ทั้งหมด", totalCount: dayDataMaster.length },
                ...computeTabStatus(dayDataMaster)
              ].map((item, index) => (
                <Tag
                  key={index}
                  color={getStatusColor(item.status)}
                  onClick={() => handleDetailFilterStatus(item.status)}
                  style={{
                    padding: '4px 12px',
                    cursor: 'pointer',
                    outline: detailFilterStatus === item.status ? '2px solid #1677ff' : 'none',
                    outlineOffset: '2px',
                    opacity: detailFilterStatus === item.status ? 1 : 0.75,
                  }}
                >
                  <span style={{ fontWeight: 'bold' }}>
                    {item.nameStatus}
                    <span style={{ marginLeft: 6, opacity: 0.8 }}>({item.totalCount})</span>
                  </span>
                </Tag>
              ))}
            </div>
          </Col>
          <Col span={24}><Divider style={{ margin: '8px 0' }} /></Col>
          <Col span={12} style={{ textAlign: "start", marginTop: "5px" }}>
            <Space>
              <Button type='primary' danger icon={<SendOutlined />} disabled={selectedRowKeys?.length === 0} onClick={() => selectedRowDatas?.length > 0 && setIsModalCheckThaiPost(true)}>
                ตรวจสอบไปรษณีย์
              </Button>
              {activeCalendarTab === "post" && (
                <Button type='primary' style={{ backgroundColor: 'green' }} icon={<CheckOutlined />} disabled={dayData?.length === 0} onClick={() => dayData?.length > 0 && setIsModalConfirmLetter(true)}>
                  คอนเฟิร์ม
                </Button>
              )}
            </Space>
          </Col>
          <Col span={12} style={{ textAlign: "end", marginTop: "5px" }}>
            <Space.Compact>
              <Input
                placeholder="ค้นหาสัญญา / ชื่อ / EMS"
                value={detailSearchText}
                onChange={e => {
                  setDetailSearchText(e.target.value);
                  if (e.target.value === "") onDetailSearch("");
                }}
                onPressEnter={() => onDetailSearch(detailSearchText)}
                style={{ width: 220 }}
              />
              <Button type="primary" icon={<SearchOutlined />} onClick={() => onDetailSearch(detailSearchText)} />
            </Space.Compact>
          </Col>
        </Row>
        <Table
          rowSelection={rowSelection}
          style={{ marginTop: "10px" }}
          size="small"
          columns={columns}
          dataSource={dayData}
          scroll={{ x: 850 }}
          footer={() => <p>จำนวนสัญญาที่ค้นหาทั้งหมด {dayData?.length}</p>}
        />
      </Card>
      {isModalCheckThaiPost && (
        <CheckThaiPost open={isModalCheckThaiPost} close={setIsModalCheckThaiPost} data={selectedRowDatas} loadData={onReload} />
      )}
      {isModalConfirmLetter && (
        <ConfirmLetter open={isModalConfirmLetter} close={setIsModalConfirmLetter} data={dayData} setDayData={setDayData} loadData={onReload} />
      )}
    </>
  );
}

export default DetailView;
